import React from 'react';
import { classNames } from '../../utils/style';
import { ImageProps } from '../Image/types';
import { Image } from '../Image';

export interface CardContentImageProps extends ImageProps {
  /** Additional className for the Image component */
  classNameImage?: string;
  /** Whether to show the overlay gradient */
  overlay?: boolean;
}

/**
 * CardContentImage component displays an image with optional overlay
 * and custom styling within a card.
 */
export const CardContentImage = ({
  classNameImage,
  className,
  children,
  overlay = true,
  ...props
}: CardContentImageProps) => {
  return (
    <div className={classNames('relative', className)}>
      <Image
        {...props}
        className={classNames(
          'w-full h-full rounded-18 object-cover',
          classNameImage,
        )}
      />

      {overlay && (
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))',
          }}
        />
      )}
      {children}
    </div>
  );
};
